import classNames from 'classnames';
import { forwardRef } from 'react';
const menuGroupCss = "m1l5u7rn";
const MenuGroup = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(menuGroupCss, props.className)} />;
});
export default MenuGroup;

require("./menu_group.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./menu_group.js");